<template>
<div>
  <span :style="starStyle" v-for="(item, index) in all" :key="index" @click="set(index)" class="iconfont" :class="{'icon-xing':index<=i,'icon-xing2':index>i}"></span>
</div>
</template>

<script>
export default {
  props: {
    starStyle: {
      type: Object | String
    },
    num: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      all: 5, // 星的个数
      i: 4 // 默认的展示几星
    }
  },
  created() {
    if (this.num > 0) {
      this.i = this.num - 1
    }
  },
  methods: {
    set(i) {
      // 传了 num 说明这个是展示用的，就不能修改
      if (this.num > 0) return
      this.i = i
    },
    getStars() {
      return this.i + 1
    }
  }
}
</script>

<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .icon-xing{
    color $color-theme
  }
  .icon-xing2{
    color #999
    font-weight 500
  }
</style>


// WEBPACK FOOTER //
// src/components/base/ui/stars.vue